import {Routes} from '@angular/router';

export const routes: Routes = [

    // Admin precisa vir antes do public - `path: ''` com prefix-match casa qualquer URL,
    // se viesse primeiro `/admin/X` seria capturado pelo wildcard 404 do public em vez do admin.
    {
        path: 'admin',
        loadChildren: () => import('./view/admin/admin.routes').then(m => m.routes)
    },

    {
        path: '',
        loadChildren: () => import('./view/public/public.module').then(m => m.PublicModule)
    }

];
